import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["product", "rental"]
  connect() { this.toggle() }
  toggle() {
    const kind = this.element.querySelector("input[name='item[kind]']:checked")?.value || "product"
    this.productTarget.hidden = kind !== "product"
    this.rentalTarget.hidden = kind !== "rental"
  }
}
